module.exports = __webpack_public_path__ + "static/media/icon-underline.a9bb6f50.svg";